export const CHAT_ID = 'search' as const
